export interface SourceSystemPkey {[ key: string ]: string };

export interface AdminSourceSystem {
   id: number;
   sourceSystem: string;
   sourceSystemPkey: SourceSystemPkey;
   users?: number;
}

export class AdminSourceSystem implements AdminSourceSystem {
   constructor( s: AdminSourceSystem ) {
      this.id = s?.id;
      this.sourceSystem = s?.sourceSystem;
      this.sourceSystemPkey = s?.sourceSystemPkey;
      if ( s?.users ) { this.users = s?.users; }
   }
}

export interface AdminSourceSystemBySystem {
   sourceSystem: string;
   sourceSystemPkey: SourceSystemPkey;
   services: number[];
}

export class AdminSourceSystemBySystem {
   constructor( s: AdminSourceSystemBySystem ) {
      this.sourceSystem = s.sourceSystem;
      this.sourceSystemPkey = s.sourceSystemPkey;

      this.services = [ ...new Set( s?.services )];
   }
}
